
    import DrugTest from '@/RootComponents/Participant/DrugTest.vue';
	import { defineComponent } from 'vue';

	export default defineComponent({
		name: "drug-test-wrapper",
		components: { DrugTest },
	});
